import { Breadcrumb } from "antd";
import { ItemType } from "antd/es/breadcrumb/Breadcrumb";
import React, { useMemo } from "react";
import { trailIfTooLong } from "../../utils/misc/strings";

type Props = {
  pageName: "events" | "event" | "newEvent" | "action" | "newAction";
  eventId?: number;
  eventName?: string | null;
  actionId?: number;
  actionName?: string | null;
};

const Breadcrumbs: React.FC<Props> = ({
  pageName,
  eventName,
  eventId,
  actionName,
  actionId,
}) => {
  const breadcrumbItems = useMemo(() => {
    const items: ItemType[] = [
      {
        href: "/",
        title: "Tableau de bord",
        className: "text-light-blue",
      },
    ];

    if (pageName === "event") {
      items.push({
        href: "/events",
        title: "ÃvÃ©nements",
        className: "text-light-blue",
      });
      items.push({
        href: `/events/${eventId}`,
        title: trailIfTooLong(eventName) || `#${eventId}`,
      });
    }

    if (pageName === "action") {
      items.push({
        href: "/events",
        title: "ÃvÃ©nements",
        className: "text-light-blue",
      });
      items.push({
        href: `/events/${eventId}`,
        title: trailIfTooLong(eventName) || `#${eventId}`,
        className: "text-light-blue",
      });
      items.push({
        href: `/events/${eventId}`,
        title: "Plan d'actions",
        className: "text-light-blue",
      });
      items.push({
        title: trailIfTooLong(actionName) || `#${actionId}`,
        href: `/events/${eventId}/actions/${actionId}`,
        className: "text-bold-black",
      });
    }

    if (pageName === "newEvent") {
      items.push({
        href: "/events",
        title: "ÃvÃ©nements",
        className: "text-light-blue",
      });
      items.push({
        href: "/events/new",
        title: "Nouvel Ã©vÃ©nement",
      });
    }

    if (pageName === "newAction") {
      items.push({
        href: "/events",
        title: "ÃvÃ©nements",
        className: "text-light-blue",
      });
      items.push({
        href: `/events/${eventId}`,
        title: trailIfTooLong(eventName) || `#${eventId}`,
        className: "text-light-blue",
      });
      items.push({
        href: `/events/${eventId}`,
        title: "Plan d'actions",
        className: "text-light-blue",
      });
      items.push({
        title: "Nouvelle action",
        href: `/events/${eventId}/actions/new`,
      });
    }
    return items;
  }, [pageName, eventId, eventName, actionName, actionId]);

  return (
    <Breadcrumb
      separator=">"
      style={{ margin: "16px 0" }}
      items={breadcrumbItems}
    />
  );
};

export default Breadcrumbs;
